<template>
    <v-card class="p-3" v-if="referent !== null && referent !== undefined">
        <h5>Référent</h5>

        <div class="d-flex justify-content-between">
            <div>
                <v-icon class="text-primary">person</v-icon>
                <span>{{ referent.email }}</span>

                <v-progress-circular class="progressbar ml-3" indeterminate v-if="loading" size="25" width="3">
                </v-progress-circular>
            </div>

            <v-btn icon @click="prepareOpenModal">
                <v-icon class="text-primary">edit</v-icon>
            </v-btn>
        </div>

        <v-dialog v-model="openModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Modifier le référent</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field v-model="email" label="E-mail" class="mb-2" outlined>
                    </v-text-field>

                    <div class="d-flex justiofy-content-end align-items-center gap-10">
                        <v-btn @click="openModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="updateReferent()">
                            Modifier le référent
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
export default {
    name: "ReferentBloc",
    props: ['referent', 'providerId'],
    data() {
        return {
            email: null,
            loading: false,
            openModal: false
        }
    },
    methods: {
        updateReferent() {
            let payload = {
                email: this.email,
                providerId: this.providerId
            }

            this.loading = true

            this.$http.post('auth/providers/referent/update', payload).then(res => {
                this.loading = false
                this.openModal = false

                this.referent.email = this.email
            })
        },
        prepareOpenModal() {
            this.email = JSON.parse(JSON.stringify(this.referent.email))
            this.openModal = true
        },
    }
}
</script>